<template>
  <div style="position: relative; height: 300px; width: 100%">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'

export default {
  name: 'ParticipantesChart',
  extends: Doughnut,
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'right',
          labels: {
            fontColor: '#6e6e6e',
            fontSize: 14,
            padding: 20
          }
        },
        cutoutPercentage: 70,
        animation: {
          animateScale: true,
          animateRotate: true
        }
      })
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart(this.chartData, this.options)
      },
      deep: true
    }
  }
}
</script>
